import React from "react";

// Mui Styles
// import { styled } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";
import IconButton from "@mui/material/IconButton";

// CSS
import "@/styles/page/systemSettingProductPage.css";

// Navigate
import { useNavigate } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import { mergeDeliveryOrderManageTableColumn } from "@/config/tableColumnConfig";
import DataTable from "@/components/dataTable";
import MergeDeliveryOrderDialog from "@/components/Dialog/mergeDeliveryOrderDialog";

// Mui Icon
import CallMerge from "@mui/icons-material/CallMerge";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import DownloadIcon from "@mui/icons-material/Download";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";

//import generate csv library
import { CSVLink } from "react-csv";

// Fetch
import {
  getPendingDeliveryOrderItemList,
  mergeDeliveryOrderItem,
} from "@/fetch/fetchStock";

import _ from "lodash";
const MergeDeliveryOrderPage = (props) => {
  const { open, setOpen } = props;
  const [selectedRows, setSelectedRows] = React.useState([]);
  const fileReader = new FileReader();
  const [filterAdmin, setFilterAdmin] = React.useState(true);
  // Navigate
  const navigate = useNavigate();

  // create a headers for generate csv file
  const headers = [
    { label: "id", key: "id" },
    { label: "staff_code", key: "staff_code" },
    { label: "full_name", key: "full_name" },
    { label: "item_name", key: "item_name" },
    { label: "delivery_qty", key: "delivery_qty" },
    { label: "stockonhand_refill_id", key: "stockonhand_refill_id" },
  ];

  // States
  const [productData, setProductData] = React.useState([]);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [dataTableLoading, setDataTableLoading] = React.useState(false);

  const handleAddClick = () => {
    setDialogOpen((prev) => !prev);
  };

  // Fetch
  const fetchAll = async () => {
    try {
      setDataTableLoading(true);
      await getPendingDeliveryOrderItemList(filterAdmin).then((data) => {
        if (data && data.results) {
          setProductData(data.data);
        } else {
          setProductData([]);
        }
      });
    } catch (error) {
      setDataTableLoading(false);
    }
  };
  const handleOnChangeUpload = (e) => {
    e.preventDefault();
    const file = e.target.files[0];

    if (file) {
      fileReader.onload = async function (event) {
        const text = event.target.result;

        const quoteChar = '"';
        const delimiter = ",";

        const regex = new RegExp(
          `\\s*(${quoteChar})?(.*?)\\1\\s*(?:${delimiter}|$)`,
          "gs"
        );

        const match = (line) =>
          [...line.matchAll(regex)]
            .map((m) => m[2]) // we only want the second capture group
            .slice(0, -1); // cut off blank match at the end

        var lines = text.split("\n");
        var result = [];

        // Read first row and display first column
        // var readVersion = lines[0].split(",");
        // var version = readVersion[0];

        var headers = match(lines.shift());
        // var headers = lines[1].split(",");
        // for (let i = 0; i < headers.length; i++) {
        //   headers[i] = headers[i].replace(`\r`, "");
        // }

        // Rows, skip 0
        for (var i = 0; i < lines.length; i++) {
          var obj = {};
          var currentline = match(lines[i]);

          // Columns
          for (var j = 0; j < headers.length; j++) {
            if (currentline[j] !== "" && currentline[j] !== undefined) {
              obj[headers[j]] = currentline[j];
            }
          }

          result.push(obj);
        }
        // Output
        await mergeDeliveryOrderItem(result).then((data) => {
          if (data.results) {
            setSnackMessage(`上傳成功`);
          } else {
            setSnackMessage(`上傳失敗`);
          }
          setSnackOpen(true);
          setTimeout(() => {
            setSnackOpen(false);
          }, 3000);
        });
        fetchAll();
      };

      fileReader.readAsText(file);
    }
    e.target.value = null;
  };
  // Browser Back
  const handleBeforeUnload = (e) => {
    e.preventDefault();
    const message =
      "Are you sure you want to leave? All provided data will be lost.";
    e.returnValue = message;
    return message;
  };
  const handleOnSubmit = async (stockonhand_refill_id) => {
    const formData = _.map(selectedRows, (selectedRow) => {
      return {
        id: selectedRow,
        stockonhand_refill_id,
      };
    });
    await mergeDeliveryOrderItem(formData).then((data) => {
      if (data.results) {
        setSnackMessage(`組合成功`);
      } else {
        setSnackMessage(`組合失敗`);
      }
      setSnackOpen(true);
      setTimeout(() => {
        setSnackOpen(false);
      }, 3000);
      setDialogOpen(false);
    });
    fetchAll();
  };
  React.useEffect(() => {
    fetchAll();

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterAdmin]);

  return (
    <Layout
      selectedIndex={18}
      header="mergeDeliveryOrderPage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title="組合運送單"
        history={() => navigate(-1)}
        children={
          <div>
            {/* Add Record */}
            <IconButton
              component="label"
              onClick={() => setFilterAdmin(!filterAdmin)}
            >
              {filterAdmin ? <FilterAltIcon /> : <FilterAltOffIcon />}
            </IconButton>
            <IconButton
              component="label"
              onClick={() => handleAddClick()}
              disabled={selectedRows.length <= 0 ? true : false}
              color={"primary"}
            >
              <CallMerge />
            </IconButton>
            <IconButton component="label">
              <DriveFolderUploadIcon />
              <input
                hidden
                type={"file"}
                id={"csvFileInput"}
                accept={".csv"}
                onChange={(e) => {
                  handleOnChangeUpload(e);
                }}
              />
            </IconButton>
            <CSVLink
              data={productData}
              filename={`Delivery Order List - ${moment(Date.startDate).format(
                "YYYY-MM-DD"
              )} to ${moment(Date.endDate).format("YYYY-MM-DD")} `}
              headers={headers}
            >
              <IconButton component="label">
                <DownloadIcon />
              </IconButton>
            </CSVLink>
          </div>
        }
      />
      <StyledPaper page={"yes"}>
        <MergeDeliveryOrderDialog
          open={dialogOpen}
          onCancel={() => setDialogOpen(false)}
          onSubmit={(stockonhand_refill_id) =>
            handleOnSubmit(stockonhand_refill_id)
          }
        />
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            rows={productData}
            checkboxSelection
            columns={mergeDeliveryOrderManageTableColumn}
            pageSize={100}
            onCellClick={() => {}}
            toolBar={false}
            onSelectionModelChange={(ids) => {
              setSelectedRows(ids);
            }}
            initialState={{
              sorting: {
                sortModel: [{ field: "brand_types_name", sort: "asc" }],
              },
            }}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default MergeDeliveryOrderPage;
